export default "__VITE_ASSET__AMUkBX2j__"